<template>
 <div class='trainDetails'>
     <div id="trainDetailsBac"></div>
     <div :class="pageHeaderSetting === 1 ? 'opctiyTop1' : 'opctiyTop'" class="trainDetail-top-opctiy"></div>
    <div class="trainDetails-title">
        <div class="trainDetails-title-top" @click="back">
            <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
        </div>
        <div class="trainDetails-title-content" v-if="taskDetailobj.name">
            <img class="trainDetails-title-content-img" :src="taskDetailobj.coverUrl" alt="">
            <div class="trainDetails-title-content-right">
                <h4>{{taskDetailobj.name}}</h4>
                <p class="study-length _clear" v-if="taskDetailobj.courseNum>0"><img src="../../../assets/images/learning/time1.png" alt="">学习时长{{taskDetailobj.learnTotalTime | formateTime}}小时 <span>|</span>已完成{{taskDetailobj.studyProcess}}%</p>
                <p class="mission-cycle">任务周期：{{taskDetailobj.cycleType!==3?formatTime1(taskDetailobj.startTime)+' ~ '+formatTime1(taskDetailobj.endTime):'长期有效'}}</p>
            </div>
        </div>
    </div>
    <div class="trainDetails-tab">
        <ul class="trainDetails-tab-list">
            <li class="trainDetails-tab-item" v-for="(item,index) in contentType" :key="index" @click="tabclick(item.id)" :class="item.id===changetype?'actived':''">{{item.name}}</li>
        </ul>
    </div>
    <div class="trainDetails-content-detail" v-if="changetype===0">
        <p v-html="taskDetailobj.description"></p>
    </div>

    <div class="trainDetails-content"  v-if="changetype===1">
        <div v-if="isHaveLive" style="font-size:0.7rem;color:red;margin-bottom:1rem;">
            <template v-if="!isIOS">安卓系统请使用微信信内嵌浏览器/Chrome浏览器。因为版权限制，华为手机不支持此功能。</template>
            <template v-else>苹果手机系统版本要求14.3以上，请使用微信信内嵌浏览器/Chrome浏览器。</template>
            <!-- <a href="https://cloud.tencent.com/document/product/647/17249" style="color:rgb(45, 103, 255);text-decoration: underline">查看支持的平台</a> -->
        </div>
        <div v-if="taskDetailobj.taskItemVoList && taskDetailobj.taskItemVoList.length>0">
            <ul>
                <li class="trainDetails-content-li-box" v-for="item in taskDetailobj.taskItemVoList" :key="item.id" @click="gonext(item,1)">
                    <!-- 线下实训 -->
                    <div class="trainDetails-content-li-order" v-if="item.type ==1 && item.isTraining">
                        <div class="trainDetails-content-title">
                            <div class="content">
                                <div class="top">
                                    <p class="trainTip">线下实训</p>
                                    <p :class="'cname1'">{{item.stageName}}</p>
                                </div>
                                <div class="bottom" v-if="item.isReserved">
                                    <p class="order" :class="childItem.trainingResult === 1 ? 'color-unpass':childItem.trainingResult === 0?'color-pass':''">
                                        {{ConstData.trainingResult[childItem.trainingResult].text}}
                                    </p>
                                </div>
                                <div class="bottom" v-else>
                                    <p class="order" >未预约</p>
                                </div>
                            </div>
                            <div class="order-button " v-show="item.trainingResult != 1"  :class="!item.isTrainingCanReserve && !item.isReserved?'gray':''" >
                                {{item.isReserved && item.trainingResult != 0?'查看预约':'预约'}}
                            </div>

                        </div>

                    </div>

                    <div v-else
                        :class="[
                            'trainDetails-content-li',
                            currentCourseId !== item.id?'trainDetails-content-li-none':'',
                            item.type===1?'trainDetails-content-li-one':'',
                            item.isLocked?'trainDetails-content-li-glay':''
                        ]">

                        <div  class="trainDetails-content-title">
                            <!-- 任务大纲图标及标题 -->
                            <p :class="(!item.submitStatus && item.type===6) || item.isLocked? 'trainTip1' : 'trainTip'" v-if="item.type!==1">
                                {{ConstData.taskContentType[item.type].text}}
                            </p>
                            <p :class="item.isLocked && !item.submitStatus ? 'cname1' : 'cname'">
                                {{ item.type===1 ? item.stageName : item.contentName }}
                            </p>

                            <!-- 展开任务小图标 -->
                            <div class="open" v-if="item.type===1 && !item.isLocked" :class="currentCourseId === item.id && 'actived'">
                                <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
                            </div>

                            <div class="course-status" v-else-if="!item.isLocked && item.studyProcess">
                                {{ item.studyProcess || 0 }}%
                            </div>
                            <div :class="item.isLocked ? 'course-status1':( item.submitStatus ? 'course-status' : 'course-status2')" v-if="item.type===6">
                                {{item.submitStatus ? '已填写' : '未填写'}}
                            </div>
                            <div @click.stop="jumpReplay(item)" class="course-status" v-else-if=" !item.isLocked && item.type===4 && item.isLiveReplay && item.status === 2">
                                观看回放
                            </div>
                            <div class="course-status" v-if="item.isLocked">
                                <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                            </div>

                            <!-- 上次学习标记 -->
                            <!-- <div v-if="">

                            </div> -->
                        </div>
                        <div class="course-time" v-if="item.type===3">{{item.isLimitTime===1?formatTime(item.contentStartTime)+' ~ '+formatTime(item.contentEndTime):'长期有效'}}</div>
                        <div class="course-time" v-if="item.type === 4">{{formatTime(item.contentStartTime)+' ~ '+formatTime(item.contentEndTime)}}</div>
                        <div class="course-time" v-if="item.type===6 && item.contentEndTime">结束时间:{{formatTime(item.contentEndTime)}}</div>

                    </div>

                    <ul v-if="currentCourseId === item.id">
                         <li v-for="(childItem) in item.childItemList" :key="childItem.id" @click="gonext(childItem)">
                            <div class="trainDetails-content-li-order" v-if="childItem.type ==1 && childItem.isTraining">
                                <div class="trainDetails-content-title">
                                    <div class="content">
                                        <div class="top">
                                            <p class="trainTip">线下实训</p>
                                            <p :class="'cname1'">{{childItem.stageName}}</p>
                                        </div>
                                        <div class="bottom" v-if="childItem.isReserved">
                                            <p class="order" :class="childItem.trainingResult === 1 ? 'color-unpass':childItem.trainingResult === 0?'color-pass':''">
                                                {{ConstData.trainingResult[childItem.trainingResult].text}}
                                            </p>
                                        </div>
                                        <div class="bottom" v-else>
                                            <p class="order" >未预约</p>
                                        </div>
                                    </div>
                                    <div class="order-button " v-show="childItem.trainingResult != 1"  :class="!childItem.isTrainingCanReserve && !childItem.isReserved?'gray':''" >
                                        {{childItem.isReserved && childItem.trainingResult != 0?'查看预约':'预约'}}
                                    </div>
                                </div>
                            </div>
                            <div v-else :class="['trainDetails-content-li',childItem.type===1?'trainDetails-content-li-two':'',childItem.childItemList.length===0 && item.childItemList.length===(childIndex+1)?'trainDetails-content-li-none':'',childItem.isLocked?'trainDetails-content-li-glay':'']" >

                                <div class="trainDetails-content-title" >
                                    <p :class="(!childItem.submitStatus && childItem.type===6) || childItem.isLocked ? 'trainTip1' : 'trainTip'" v-if="childItem.type!==1">
                                        {{ConstData.taskContentType[item.type].text}}
                                    </p>
                                    <!-- stageName 还是 contentName？？？ -->
                                    <p :class="childItem.isLocked && !childItem.submitStatus ? 'cname1' : 'cname'">
                                        {{ childItem.contentName || childItem.stageName }}
                                    </p>

                                    <div class="course-status" v-if="!childItem.isLocked && childItem.studyProcess">
                                        {{ childItem.studyProcess || 0 }}%
                                    </div>
                                    <div :class="childItem.isLocked ? 'course-status1':( childItem.submitStatus ? 'course-status' : 'course-status2')" v-if="childItem.type===6">
                                        {{childItem.submitStatus ? '已填写' : '未填写'}}
                                    </div>
                                    <div @click.stop="jumpReplay(childItem)" class="course-status" v-if="!childItem.isLocked && childItem.type===4 && childItem.isLiveReplay && childItem.status === 2">
                                        观看回放
                                    </div>
                                    <div class="course-status" v-if="childItem.isLocked">
                                        <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                                    </div>
                                </div>
                                <div class="course-time" v-if="childItem.type===3">{{childItem.isLimitTime===1?formatTime(childItem.contentStartTime)+' ~ '+formatTime(childItem.contentEndTime):'长期有效'}}</div>
                                <div class="course-time" v-if="childItem.type === 4">{{formatTime(childItem.contentStartTime)+' ~ '+formatTime(childItem.contentEndTime)}}</div>
                                <div class="course-time" v-if="childItem.type===6 && childItem.contentEndTime">结束时间:{{formatTime(childItem.contentEndTime)}}</div>
                            </div>
                            <ul>
                                <li v-for="(childItem1,childIndex1) in childItem.childItemList" :key="childItem1.id" @click="gonext(childItem1)">
                                    <div class="trainDetails-content-li-order" v-if="childItem1.type ==1 && childItem1.isTraining">
                                        <div class="trainDetails-content-title">
                                            <div class="content">
                                                <div class="top">
                                                    <p class="trainTip">线下实训</p>
                                                    <p :class="'cname1'">{{childItem1.stageName}}</p>
                                                </div>
                                                <div class="bottom" v-if="childItem1.isReserved">
                                                    <p class="order" :class="childItem.trainingResult === 1 ? 'color-unpass':childItem.trainingResult === 0?'color-pass':''">
                                                        {{ConstData.trainingResult[childItem.trainingResult].text}}
                                                    </p>

                                                </div>
                                                <div class="bottom" v-else>
                                                    <p class="order" >未预约</p>
                                                </div>
                                            </div>
                                            <div class="order-button " v-show="childItem1.trainingResult != 1"  :class="!childItem1.isTrainingCanReserve && !childItem1.isReserved?'gray':''" >
                                                {{childItem1.isReserved && childItem1.trainingResult != 0?'查看预约':'预约'}}
                                            </div>

                                        </div>

                                    </div>
                                    <div v-else :class="['trainDetails-content-li',childItem1.type===1?'trainDetails-content-li-three':'',childItem1.childItemList.length===0 && childItem.childItemList.length===(childIndex1+1)?'trainDetails-content-li-none':'',childItem1.isLocked?'trainDetails-content-li-glay':'']" >
                                        <div class="trainDetails-content-title">
                                            <p :class="(!childItem1.submitStatus && childItem1.type===6) || childItem1.isLocked ? 'trainTip1' : 'trainTip'" v-if="childItem1.type!==1">
                                                {{ConstData.taskContentType[item.type].text}}
                                            </p>
                                            <p :class="childItem1.isLocked && !childItem1.submitStatus ? 'cname1' : 'cname'">{{ childItem1.contentName }}</p>

                                            <div class="course-status" v-if="!childItem1.isLocked && childItem1.studyProcess">
                                                {{ childItem1.studyProcess || 0 }}%
                                            </div>
                                            <div :class="childItem1.isLocked ? 'course-status1':( childItem1.submitStatus ? 'course-status' : 'course-status2')" v-if="childItem1.type===6">
                                                {{childItem1.submitStatus ? '已填写' : '未填写'}}
                                            </div>
                                            <div @click.stop="jumpReplay(childItem1)" class="course-status" v-if="!childItem1.isLocked && childItem1.type===4 && childItem1.isLiveReplay && childItem1.status === 2">
                                                观看回放
                                            </div>
                                            <div class="course-status" v-if="childItem1.isLocked">
                                                <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                                            </div>
                                        </div>
                                        <div class="course-time" v-if="childItem1.type===3">{{childItem1.isLimitTime===1?formatTime(childItem1.contentStartTime)+' ~ '+formatTime(childItem1.contentEndTime):'长期有效'}}</div>
                                        <div class="course-time" v-if="childItem1.type === 4">{{formatTime(childItem1.contentStartTime)+' ~ '+formatTime(childItem1.contentEndTime)}}</div>
                                        <div class="course-time" v-if="childItem1.type===6 && childItem1.contentEndTime">结束时间:{{formatTime(childItem1.contentEndTime)}}</div>

                                    </div>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </li>
            </ul>
        </div>

    </div>
    <van-dialog class="traindialog" v-model="trainshow" :show-confirm-button="false">
        <div class="traindialog-content">{{traintxt}}</div>
        <van-button class="traindialog-btn" @click="trainshowbtn">知道了（{{count}}S后关闭）</van-button>
    </van-dialog>
    <div v-show="false" ref="audioRef">音频</div>

    <div v-if="canToQuicklyStudy" class="detail-foot" :class="{ isMinzheng:theme === 'minzheng' }">
        <button v-if="taskDetailobj.studyProcess" @click="quicklyStudy">继续学习</button>
        <button v-else @click="quicklyStudy">立即学习</button>
    </div>

 </div>
</template>

<script>
import { goLiveHome } from '../../../utils/livePlatform'
export default {
    name:'trainDetails',
    data () {
        return {
            taskId:'',
            lastStudyCourseId:'',
            lastPlayItemId:'',
            count:2,
            traintxt:'',
            trainshow:false,
            changetype: 1,
            contentType: [
                { name: "简介", id: 0 },
                { name: "目录", id: 1 }
            ],
            taskDetailobj:{},
            currentCourseId: null,
            theme:'',
            canToQuicklyStudy:false, // 按钮显示
            isHaveLive:false,
            isIOS:false,
            pageHeaderSetting: null, // cms 是否配置导航头
        };
    },
    components: {

    },
    filters: {
        formateTime: function(val) {
            return val ? (val / 3600).toFixed(2) : val;
        }
    },
    watch:{
         trainshow: {
            handler(n) {
               if(n===true && this.count>0){
                    let clear=setInterval(()=>{
                        this.count--;
                        if(this.count<=0){
                            this.trainshow=false;
                            clearInterval(clear);
                        }
                    },1000);
               }
            },
            immediate: true
        },
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
    },
    created(){
        this.initTemp();
        this.theme = sessionStorage.getItem('theme')
        if(this.$route.query.id){
            this.getTaskDetail(this.$route.query.id);
            this.taskId = this.$route.query.id
            // 获取快速学习的课程信息
            this.getQuicklyStudyInfo()
        }
        this.isIosOrAn();
    },
    methods: {
        isIosOrAn(){
            var browser = {
                versions: function () {
                    var u = navigator.userAgent, app = navigator.appVersion;
                    return {//移动终端浏览器版本信息
                        trident: u.indexOf('Trident') > -1, //IE内核
                        presto: u.indexOf('Presto') > -1, //opera内核
                        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
                        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
                        iPad: u.indexOf('iPad') > -1, //是否iPad
                        webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
                    };
                }(),
                language: (navigator.browserLanguage || navigator.language).toLowerCase()
            }

            if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
                console.log("是苹果系统");
                this.isIOS = true;
            }
            else if (browser.versions.android) {
                console.log("是安卓系统");
                this.isIOS = false;
            }
        },
        getQuicklyStudyInfo(){
            const taskType = 2
            this.$api.learning.quicklyStudy(this.taskId,taskType).then( res => {
                if(res.code == 0 && res.data){
                    this.canToQuicklyStudy = true
                    this.lastStudyCourseId = res.data.courseId
                    this.lastPlayItemId = res.data.lastPlayItemId
                }
            })
        },
        quicklyStudy(){
            localStorage.setItem("faceidentify", 0);
            this.$router.push({
                path: "/scourse",
                query: {
                    courseId: this.lastStudyCourseId,
                    trainId: this.taskId,
                    taskType:2,
                    backType:this.$route.query.backType
                }
            });
        },
        jumpReplay(item) {
            console.log('观看回放')
            // && childItem1.isReplay
          this.$api.live.getBjyPlayUrl({liveCourseId: item.contentId}).then(async (resB) => {
            if(resB.data.roomStatus==1){ // 腾讯
              if(item.isReplay){
                goLiveHome(this, item.contentId,item)
                //  && info.isReplay ==1
                // this.$api.live.liveCourseReplay({id: item.contentId}).then(async (res) => {
                //   if (res.success) {
                //     console.log('res===', res)
                //     this.$router.push({
                //       path: '/replay',
                //       query:{
                //         roomId: item.contentId,
                //         replayResourceId: item.replayResourceId
                //         // roomId: 808,
                //         // replayResourceId: 1
                //       }
                //     })
                //   }
                // });
              } else {
                this.$toast('视频转码中~')
              }
            }else if(resB.data.roomStatus==2 || resB.data.roomStatus==6 || resB.data.roomStatus==4){ // 百家云 cc
              if(!item.isReplay){
                  this.$toast({
                    message:'视频转码中~',
                    duration: 3000,
                });
                return false
              }
              goLiveHome(this, item.contentId,item)
              // this.$api.live.liveCourseReplay({id: item.contentId}).then(async (res) => {
              //   if (res.success) {
              //     this.$router.push({
              //       path: '/bjyLivePlayBack',
              //       query:{
              //         contentId: item.contentId,
              //       }
              //     })
              //   }
              // })
            }
          });

        },
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.')+' '+val.split(' ')[1].split(':').slice(0,2).join(':')
            }
        },
        formatTime1(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.');
            }
        },

        tabclick(id){
            this.changetype=id;
        },
        back() {
            if(this.$route.query.usego) {
                this.$router.go(-1);
                return false;
            }
            if(this.$route.query.backPath){
                this.$router.push({
                    path: this.$route.query.backPath,
                    query: {
                        goodsId:this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                        distributionUserId:this.$route.query.distributionUserId,
                    }
                })
            }else{
                this.$router.push({
                    name: "learning",
                    query:{
                        backType:this.$route.query.backType
                    }
                });
            }
        },
        trainshowbtn(){
            this.trainshow=false;

        },
        gonext(item,type, ){
            /**
             * 人脸识别需要用到
             */
            localStorage.setItem("faceidentify", 0);
            /*** end */
            // let txt=item.lockExamCondition===1?'，考试及格':'';
            if(item.isLocked){
                if(this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition===1 && this.taskDetailobj.isFormCommit){
                    this.traintxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskDetailobj.lockCourseRate+'%，考试及格，表单提交';
                }else if(this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition===0 && this.taskDetailobj.isFormCommit){
                    this.traintxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskDetailobj.lockCourseRate+'%，表单提交';
                }else if(!this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition===0 && this.taskDetailobj.isFormCommit){
                    this.traintxt='该章未开启，开启条件为表单提交';
                } else if(!this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition===1 && !this.taskDetailobj.isFormCommit ){
                    this.traintxt='该章未开启，开启条件为考试及格';
                } else if(this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition===0 && !this.taskDetailobj.isFormCommit){
                    this.traintxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskDetailobj.lockCourseRate+'%';
                } else if(this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition && !this.taskDetailobj.isFormCommit ){
                    this.traintxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskDetailobj.lockCourseRate+'%，考试及格';
                } else if(!this.taskDetailobj.lockCourseRate && this.taskDetailobj.lockExamCondition && this.taskDetailobj.isFormCommit){
                    this.traintxt='该章未开启，考试及格，表单提交';
                }
                this.count=2;
                this.trainshow=true;
                return;
            }
            // 线下实训
            if(item.type === 1 && item.isTraining ) {
                if(!item.isTrainingCanReserve) {
                    if(item.trainingResult !== 1) { // 成绩不合格
                         this.$toast({
                            message: '正式考核通过后可预约',
                            position: 'middle'
                        })
                        return
                    }else {
                        return
                    }
                }
                this.$router.push({
                    path: '/subscribeList',
                    query: {
                        taskId: item.taskId,
                        searchKey: '',
                    }
                })
                return
            }
            if(item.type===1 && type===1){
                if (this.currentCourseId === item.id) {
                    this.currentCourseId = null
                } else {
                    this.currentCourseId = item.id || ''
                }
                this.$forceUpdate();
            }else if(item.type===2){
                this.goCoursedetail(item);
            }else if(item.type===3){
                this.toexamDetial(item);
            }else if(item.type===4){
                if(item.contentId){
                    this.watchLivejump(item.contentId, item.status,item)

                }else{
                    this.coursetxt='无内容，无法学习';
                    this.count=2;
                    this.courseshow=true;
                    return;
                }

            }else if(item.type===5){
                this.traintxt='线上实训无法在手机上进行，请前往电脑网页端';
                this.count=2;
                this.trainshow=true;
                return;
            } else if(item.type===6){
                    this.$router.push({
                    path:'/learning/formPage',
                    query:{
                        // type: this.$route.query.backType == 1 ? 2 : this.$route.query.backType == 2 ? 1 : null, // type：1训练营 2培训任务
                        type: 2,
                        typeId: this.$route.query.id, // typeId：训练营id或者培训任务id
                        wjId:item.contentId // wjId：问卷ID
                    }
                });
            } else if(item.type === 7) {
                this.$router.push({
                    path: '/testDetail',
                    query: {
                        businessId: item.taskId,
                        businessType: 2,
                        practiceId: item.contentId,
                        taskId: item.taskId,
                        taskType: 2,
                        backType: this.$route.query.backType,
                    }
                })
            }

        },
        watchLivejump(contentId, status, item){
          this.$api.live.getBjyPlayUrl({liveCourseId: contentId}).then(async (resB) => {
            if(resB.data.roomStatus==1){ // 腾讯
              this.$api.live.audienceEnterRoom({id: contentId}).then(async (res) => {
                if (res.success) {
                    this.$router.push({
                      path: '/watchLive',
                      query: {
                        type: '1',
                        roomId: contentId,
                        from: 'list',
                        backType:this.$route.query.backType
                      }
                    })
                }
              })
            }else if(resB.data.roomStatus==2 || resB.data.roomStatus==5){ // 百家云
              this.$router.push({
                path: '/bjyStudent',
                query: {
                  contentId: contentId
                }
              })
            }else if(resB.data.roomStatus==4){ // 百家云自定义
              if(status == 0 || status == 1){
                goLiveHome(this, contentId,item)
                // this.$router.push({
                //   path: '/bjyCustomStudent',
                //   query: {
                //     roomId: resB.data.room_id
                //   }
                // })
              } else {
                this.$toast({
                    message:'直播已结束！',
                    duration: 3000,
                });
                return false
              }
              // this.$api.live.audienceEnterRoom({id: contentId}).then(async (res) => {
              //   if (res.success) {

              //   }
              // })
            }
          });

        },
        goCoursedetail(item) {
            localStorage.setItem("faceidentify", 0);
            this.$router.push({
                path: "/scourse",
                query: {
                    courseId: item.contentId,
                    trainId: item.taskId,
                    taskType:2,
                    backType:this.$route.query.backType
                }
            });
        },
        toexamDetial(item) {
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: item.taskId,
                    contentId: item.contentId,
                    trainItemExamId: item.contentId,
                    type:2,
                    backType:this.$route.query.backType
                }
            })
        },
        getTaskDetail(id) {
            let params = {id};
            this.$api.learning.taskDetail({ params }).then((res) => {
                if(!res.data && res.message === "用户尚未添加到该培训任务"){
                    this.$router.go(-1);
                    return false;
                }
               this.taskDetailobj=res.data;
               var trainDetailsContent=document.getElementById('trainDetailsBac')
                trainDetailsContent.style.backgroundImage=`url(${this.taskDetailobj.coverUrl})`
                if(this.pageHeaderSetting === 1){
                    trainDetailsContent.classList.add('notBig1')
                }else {
                    trainDetailsContent.classList.add('notBig')
                }

                this.taskDetailobj.taskItemVoList.length && this.taskDetailobj.taskItemVoList.forEach((item,index) => {
                    if(item.type == 4){
                        this.isHaveLive = true;
                    }
                })
            });
        },
        initTemp () {
            this.getLayoutSetting()
        },
        getLayoutSetting() {
            let cmsData = JSON.parse(localStorage.getItem('setTempConfigs')) || null;
            this.pageHeaderSetting = cmsData && cmsData.pageHeaderSetting;


        }
    },
    destroyed() {
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },

}

</script>
<style lang='stylus' scoped>
@import '../css/trainDetails.less'
</style>
<style lang="stylus" scoped>
.trainDetails .trainDetails-title-content {
    position relative
}
.trainDetails {
    padding-bottom 98px;
}
.detail-foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    background: #ffffff;
    text-align: center;
    box-shadow: 0px 2px 0px 0px #EAEAEA;
    z-index: 100;
   button {
      width: 690px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
      border-radius: 44px;
      border: 0;
      font-size: 32px;
      margin-top: 10px;
      color: #ffffff;
   }
   &.isMinzheng button {
       background: #CA4C2D;
   }
}
</style>
